module.exports = __webpack_public_path__ + "SamsungSharpSans-Medium.121d562109973586a8fa.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungSharpSans-Medium.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungSharpSans-Medium.ttf
// module chunks = styles